import { request } from '../apis/';

export const TestService = {
  getFact: () => request.get<any | null>('fact')
};
